import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import AboutTabsSection from "./AboutTabs";

const About: React.FC = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">About Page</h1>
        <div className="mb-4">
          <Breadcrumb separator=">" items={[{ title: "About" }, { title: breadcrumb}]} className="text-xs sm:text-base"/>
        </div>
        <AboutTabsSection setBreadcrumb={setBreadcrumb} />
      </div>
    </div>
  );
};

export default About;
